<template>
	<div class="settings"
			 v-on:click="onClickOutside">
		<!-- Mobicar 3 PRO -->
		<div class="settings-section" v-if="activeSettingsItem === 0">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Mobicar 3 PRO
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar v-if="listServices[0]">
				<div class="settings-content">
					<div class="settings-content_col settings-content_col__space">
						<!-- Пробный период -->
						<div class="generalSettings_list"
								 v-if="listServices[0].order.status === 0 && trial.data && trial.data.days_left">
							<div class="generalSettings_list-item">
								Текущая версия системы:
							</div>
							<div class="generalSettings_list-item generalSettings_list-item__long">
								<img src="../../assets/img/mobicar/logo-black.svg"/>
								<div class="settings-typemobicar">
									Pro
								</div>
							</div>
							<div class="generalSettings_list-item__long">
								<div class="trial-title">
									Дней до конца пробного периода:
								</div>
								<div class="trial-date">{{trial.data.days_left}}</div>
							</div>
							<div class="generalSettings_list-item__long">
								<div class="generalSettings_list-item">
									<button class="btn btn-success btn-full"
													v-on:click="makePayment"
													v-if="listServices[0] && listServices[0].order.status === 0 && listServices[0].order.amount">
										Купить {{listServices[0].order.amount}}р
									</button>
								</div>
								<div>
									*нажимая кнопку «Купить», вы соглашаетесь с <a href="https://mf-t.ru/mf-t_ru_user_agreement.pdf" target="_blank">Пользовательским соглашением</a>
								</div>
							</div>
						</div>
						<!-- Не пробный период -->
						<div class="generalSettings_list" v-else>
							<div class="generalSettings_list-item">
								Текущая версия системы:
							</div>
							<div class="generalSettings_list-item generalSettings_list-item__long">
								<img src="../../assets/img/mobicar/logo-black.svg"/>
								<div class="settings-typemobicar" v-if="!deviceSetting.has_internet_connection">
									Base
								</div>
								<div class="settings-typemobicar" v-else>
									Pro
								</div>
							</div>
							<div class="generalSettings_list-item generalSettings_list-item__long"
									 v-if="listServices[0].order.status && listServices[0].order.status !== 1">
								Система Mobicar 3 PRO расширит ваши возможности управления охранной системой автомобиля.
								Для ознакомления с сервисом вы можете воспользоваться бесплатным периодом в течениe 20 дней.
							</div>
							<div class="generalSettings_list-item__long">
								<div class="generalSettings_list-item">
									<button class="btn btn-success btn-full"
													v-on:click="getCarData( true )"
													v-if="listServices[0] && listServices[0].order.status === 0 && listServices[0].order.amount">
										Купить {{listServices[0].order.amount}}р.*
									</button>
									<button class="btn btn-success btn-full"
													disabled="disabled"
													v-if="listServices[0].order.status !== 1 && listServices[0].order.status !== 0 && listServices[0].order.days_left !== null">
										Купить
									</button>
								</div>
								<div class="generalSettings_list-item"
										 v-if="trial.status === 'can' && listServices[0].order.status === 0">
									<button class="btn btn-clean btn-full btn-brd"
													v-on:click="setTrial()">Попробовать бесплатно</button>
								</div>
								<div v-if="listServices[0].order && !listServices[0].order.status && listServices[0].order.detail"
										 class="settings-operation settings-operation__warning">
									{{listServices[0].order.detail}}
								</div>
								<div v-if="listServices[0] && listServices[0].order.status === 0 && listServices[0].order.amount">
									*нажимая кнопку «Купить», вы соглашаетесь с <a href="https://mf-t.ru/mf-t_ru_user_agreement.pdf" target="_blank">Пользовательским соглашением</a>
								</div>
							</div>
						</div>
						<!-- -->
						<div class="generalSettings_list settings-mobicar-payment-descr"
								 v-if="listServices[0].order.status === 0">
							Оплата происходит через ПАО СБЕРБАНК с использованием банковских карт следующих платёжных систем:
							<div>
								<img src="../../assets/img/mobicar/settings/cards.png">
							</div>
						</div>
					</div>
					<div class="settings-content_separator" v-if="listServices[0].order.status !== undefined && listServices[0].order.status !== 1">
					</div>
					<div class="settings-content_col" v-if="listServices[0].order.status !== undefined && listServices[0].order.status !== 1">
						<div class="settings-mobicar-title">
							Mobicar 3 PRO
						</div>
						<div>
							Телематическое устройство в вашем автомобиле содержит GSM-модем и SIM-карту. С их помощью устройство передает зашифрованные данные на сервер компании «Мега-Ф». Для разрешения передачи данных необходимо установить функцию №20 (меню 2) «Подключение к серверу через интернет» в  положение «2» при помощи брелока.
							(см. <a href="https://api.mf-t.ru/media/docs/%D0%A0%D0%A3%D0%9A%D0%9E%D0%92%D0%9E%D0%94%D0%A1%D0%A2%D0%92%D0%9E_%D0%9F%D0%9E_%D0%AD%D0%9A%D0%A1%D0%9F%D0%9B%D0%A3%D0%90%D0%A2%D0%90%D0%A6%D0%98%D0%98_MOBICAR_3_0.4.pdf" target="_blank">Руководство по эксплуатации Mobicar 3</a>)
							<br>
							<br>
							Сервер запоминает все, что происходит с автомобилем - маршруты передвижения, тревожные сообщения, информацию о состоянии двигателя.
							<br>
							<br>
							Теперь ваш автомобиль всегда с вами!
							<br>
							<br>
							Где бы вы ни находились, даже на другом континенте — теперь очень просто узнать, что сейчас происходит с вашим автомобилем: где он находится и все ли с ним в порядке. Любое изменение состояния автомобиля будет немедленно отображено: открытые дверь, капот, багажник, включенные фары, различные причины возникновения тревоги и др. И вы будете немедленно проинформированы об этом изменении.
						</div>
					</div>
				</div>
				<div class="settings-mobicar-sber-descr"
						 v-if="listServices[0].order.status === 0">
					Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на платёжный шлюз ПАО СБЕРБАНК. Соединение с платёжным шлюзом и передача информации осуществляется в защищённом режиме с использованием протокола шифрования SSL. В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa, MasterCard SecureCode, MIR Accept, J-Secure для проведения платежа также может потребоваться ввод специального пароля.
					Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО СБЕРБАНК. Введённая информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платёжных систем МИР, Visa Int., MasterCard Europe Sprl, JCB.
				</div>
			</perfect-scrollbar>
		</div>
		<!-- SoundAndLights -->
		<div class="settings-section" v-if="activeSettingsItem === 1">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Звуковые сигналы и световая сигнализация
				</div>
				<p class="text-base">
					<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content">
					<div class="mobSet_content"
							 v-if="settings.formatList.SoundAndLights.length">
						<div class="settings-shared_item"
								 v-for="(item, indexItem) in settings.formatList.SoundAndLights"
								 v-bind:key="indexItem">
							<div class="mobSet_form-group__vertical"
									v-if="item.key === '0x0144'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c0"
													:options="settings.options.LightsAutoStartMode"
													:value='settings.options.LightsAutoStartMode[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item)"
													label="name"></v-select>
							</div>
							<div class="mobSet_form-group__vertical"
									v-else-if="item.key === '0x0148'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c1"
													:options="settings.options.IlluminationMode"
													:value='settings.options.IlluminationMode[item.val]'
													:searchable="false"
													:clearable="false"
													@click="onClickOutside"
													@input="setSelected(item)"
													label="name"></v-select>
							</div>
							<label class="mobSet_form-group"
										 v-on:change="setSelected(item, indexItem)"
										 v-else>
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<div class="checkbox">
									<input type="checkbox"
												 v-model="item.val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- SecuritySystem -->
		<div class="settings-section" v-if="activeSettingsItem === 2">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Параметры охранной системы
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content" v-if="settings.formatList.SecuritySystem.length">
					<div class="mobSet_content">
						<div class="settings-shared_item"
								 v-for="(item, indexItem) in settings.formatList.SecuritySystem"
                 v-if="item.val !== -1"
								 v-bind:key="indexItem">
							<div class="mobSet_form-group__vertical"
									 v-if="item.key === '0x0182'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c0"
													:options="settings.options.LockByDriveMode"
													:value='settings.options.LockByDriveMode[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name"></v-select>
							</div>
							<div class="mobSet_form-group__vertical"
									 v-else-if="item.key === '0x0187'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c1"
													:options="settings.options.UnlockByParkMode"
													:value='settings.options.UnlockByParkMode[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name"></v-select>
							</div>
							<div class="mobSet_form-group__vertical"
									 v-else-if="item.key === '0x01A3'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c2"
													:options="settings.options.ArmReturnTimeIndex"
													:value='settings.options.ArmReturnTimeIndex[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name"></v-select>
							</div>
							<div class="mobSet_form-group__vertical"
									 v-else-if="item.key === '0x01A7'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c3"
													:options="settings.options.HandsfreeMode"
													:value='settings.options.HandsfreeMode[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name"></v-select>
							</div>
							<div class="mobSet_form-group"
									v-else-if="item.key === '0x01AC'">
								<span>{{item.name}}</span>
								<label class="mobSet_form-control">
                  <masked-input v-model="item.val" mask="1111" maxlength="4" placeholder="XXXX" class="mobSet_form-field">
                  </masked-input>
								</label>
								<button class="mobSet_form-success btn btn-success"
												type="button"
												v-on:click="setSelected(item, indexItem)"
												v-bind:disabled="item.val.length < 4">Сохранить</button>
							</div>
							<div class="mobSet_form-group__vertical"
									v-else-if="item.key === '0x0290'">
                <div class="mobSet_field-name">
                  {{item.name}}
                </div>
                <vue-slider
                    ref="slider"
                    v-model="item.val"
                    v-bind="settings.options.videoReg"
                    v-on:change="changeSlider(item)"
                ></vue-slider>
                <div>
                  {{Math.round( item.val * 5 / 60 )}} мин
                </div>
							</div>
							<div class="mobSet_form-group__vertical"
									v-else-if="item.key === '0x0291'">
                <div class="mobSet_field-name">
                  {{item.name}}
                </div>
                <div style="padding-left: 20px">
                  <label class="mobSet_form-group"
                         v-on:change="setSelected(item, indexItem)"
                         v-for="(cB, cBi) in settings.options.videoRegStart">
                    <div class="mobSet_field-name">
                      {{cB.name}}
                    </div>
                    <div class="checkbox">
                      <input type="checkbox"
                             v-model="item.val[cBi]">
                      <div class="checkbox_img">
                      </div>
                    </div>
                  </label>
                </div>
							</div>
							<div class="mobSet_form-group__vertical"
									v-else-if="item.key === '0x0292'">
                <div class="mobSet_field-name">
                  {{item.name}}
                </div>
                <div style="padding-left: 20px">
                  <label class="mobSet_form-group"
                         v-on:change="setSelected(item, indexItem)"
                         v-for="(cB, cBi) in settings.options.videoRegEnd">
                    <div class="mobSet_field-name">
                      {{cB.name}}
                    </div>
                    <div class="checkbox">
                      <input type="checkbox"
                             v-model="item.val[cBi]">
                      <div class="checkbox_img">
                      </div>
                    </div>
                  </label>
                </div>
							</div>
							<div class="mobSet_form-group__vertical"
									v-else-if="item.key === '0x0293'">
                <div class="mobSet_field-name">
                  {{item.name}}
                </div>
                <vue-slider
                    ref="slider"
                    v-model="item.val"
                    v-bind="settings.options.videoReg"
                    v-on:change="changeSlider(item)"
                ></vue-slider>
                <div>
                  {{Math.round( item.val * 5 / 60 )}} мин
                </div>
							</div>
							<label class="mobSet_form-group"
										 v-on:change="setSelected(item, indexItem)"
										 v-else>
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<div class="checkbox">
									<input type="checkbox"
												 v-model="item.val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- Autostart -->
		<div class="settings-section" v-if="activeSettingsItem === 3">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Автозапуск
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content" v-if="settings.formatList.Autostart.length">
					<div class="mobSet_content">
						<div class="settings-shared_item"
								 v-if="indexItem < 9"
								 v-for="(item, indexItem) in settings.formatList.Autostart">

							<div class="mobSet_form-group__vertical"
									 v-if="item.key === '0x0240'">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c0"
													:options="settings.options.TurboTimerIndex"
													:value='settings.options.TurboTimerIndex[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name">
								</v-select>
							</div>

							<div v-else-if="item.key === '0x0241'"
									class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<vue-slider
										ref="slider"
										v-model="item.val"
										v-bind="settings.options.ReadyMinutes"
										v-on:change="changeSlider(item)"
								></vue-slider>
								<div>
									{{item.val}} мин
								</div>
							</div>

							<div v-else-if="item.key === '0x0242'"
									class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<vue-slider
										ref="slider"
										v-model="item.val"
										v-bind="settings.options.SupportMinutes"
										v-on:change="changeSlider(item)"
								></vue-slider>
								<div>
									{{item.val}} мин
								</div>
							</div>

							<div v-else-if="item.key === '0x0243'"
									 class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c1"
													:options="settings.options.PitStopTimeIndex"
													:value='settings.options.PitStopTimeIndex[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name">
								</v-select>
							</div>

							<div v-else-if="item.key === '0x0247'"
									 class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c2"
													:options="settings.options.SetReadyMode"
													:value='settings.options.SetReadyMode[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, indexItem)"
													label="name">
								</v-select>
							</div>

							<div v-else-if="item.key === '0x0254'"
									 class='mobSet_form-group__vertical'>
								<div class="mobSet_form-group">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div>
										<label class="switcher"
													 v-on:click="changeSlider(item, 126)">
											<input type="checkbox" v-model="item.val.on">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
								</div>
								<div>
									<vue-slider
											ref="slider"
											v-model="item.val.val"
											v-bind="settings.options.AutostartBatteryLevel"
											v-on:change="changeSlider(item, 126)"
									></vue-slider>
								</div>
								<div>
									{{(item.val.val/10).toFixed(1) }}
								</div>
							</div>


							<div v-else-if="item.key === '0x0255'"
									 class='mobSet_form-group__vertical'>
								<div class="mobSet_form-group">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div>
										<label class="switcher"
													 v-on:click="changeSlider(item, 60)">
											<input type="checkbox" v-model="item.val.on">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
								</div>
								<div>
									<vue-slider
											ref="slider"
											v-model="item.val.val"
											v-bind="settings.options.AutostartTemperature"
											v-on:change="changeSlider(item)"
									></vue-slider>
								</div>
								<div>
									{{item.val.val}}
								</div>
							</div>

							<label class="mobSet_form-group"
										 v-on:change="setSelected(item, indexItem)"
										 v-else>
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<div class="checkbox">
									<input type="checkbox"
												 v-model="item.val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>

						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="mobSet_content">
						<div class="settings-operation">
							<button class="btn btn-clean btn-brd"
							        v-on:click="addAutostart()">
								Добавить запуск по расписанию
							</button>
						</div>
						<div class="settings-shared_item"
								 v-if="indexItem > 8 && item.val.minuts !== ''"
								 v-for="(item, indexItem) in settings.formatList.Autostart"
								 v-bind:key="indexItem">
							<div class="autostart-status">
								<div>
									{{item.name}}
								</div>
								<label class="switcher">
									<input type="checkbox" v-model="item.val.on">
									<div class="switcher_checked">
										<div class="switcher_status">
										</div>
									</div>
									<div class="switcher_toddler">
									</div>
								</label>
							</div>
							<div class="autostart-item_cnt"
									 v-bind:class="{ 'autostart-item_cnt__passive' : !item.val.on }">
								<div class="autostart-time">
									<label>
										<masked-input v-model="item.val.fHours"
																	mask="11" maxlength="2" placeholder="XX"
																	class="field-time_hour"
																	@keyup.native="changeTime(item)">
										</masked-input>
										<span>:</span>
										<masked-input v-model="item.val.fMinuts"
																	mask="11" maxlength="2" placeholder="XX" class="field-time_minute"
																	@keyup.native="changeTime(item)">
										</masked-input>
									</label>
								</div>
								<div class="autostart-days">
									<div class="autostart-days_item"
											 v-for="(dayWeek, indexDay) in item.val.days"
											 v-bind:key="indexDay"
											 v-bind:class="{ 'autostart-days_item__active' : dayWeek === 1 }"
									     v-on:click="changeDayWeek(item, indexDay)">
										{{settings.options.dayWeek[indexDay]}}
									</div>
								</div>
							</div>
							<div class="mobSet_form-group">
								<!--<span class="btn btn-cancel">Удалить</span>-->
								<span class="btn btn-success" v-on:click="saveTimer(item)">Сохранить</span>
							</div>
							<div class="style-hr__solid">
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- ShockTiltSensors -->
		<div class="settings-section" v-if="activeSettingsItem === 4">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Датчики удара и наклона
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content"
						 v-if="settings.formatList.ShockTiltSensors.length">
					<div class="mobSet_content">
						<div v-for="item in settings.formatList.ShockTiltSensors">

							<div v-if="item.key === '0x0280'"
									class='mobSet_form-group__vertical'>
								<div class="mobSet_form-group">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div>
										<label class="switcher"
													 v-on:click="changeSlider(item, 9)">
											<input type="checkbox" v-model="item.val.on">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
								</div>
								<div v-bind:class="{ 'sliderDisabled' : !item.val.on }">
									<div>
										<vue-slider
												ref="slider"
												v-model="item.val.val"
												v-bind="settings.options.ShockNotify"
												v-on:change="changeSlider(item, 9)"
										></vue-slider>
									</div>
									<div class="slidebar_sensivity text-small">
										Чувствительность:
										<span v-if="item.val.val <= 3">Слабая</span>
										<span v-if="item.val.val > 3 && item.val.val < 8">Оптимальная</span>
										<span v-if="item.val.val >= 8">Максимальная</span>
									</div>
								</div>
							</div>

							<div v-if="item.key === '0x0281'"
									class='mobSet_form-group__vertical'>
								<div class="mobSet_form-group">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div>
										<label class="switcher"
													 v-on:click="changeSlider(item, 8)">
											<input type="checkbox" v-model="item.val.on">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
								</div>
								<div v-bind:class="{ 'sliderDisabled' : !item.val.on }">
									<div>
										<vue-slider
												ref="slider"
												v-model="item.val.val"
												v-bind="settings.options.ShockAlarm"
												v-on:change="changeSlider(item, 8)"
										></vue-slider>
									</div>
									<div class="slidebar_sensivity text-small">
										Чувствительность:
										<span v-if="item.val.val <= 3">Слабая</span>
										<span v-if="item.val.val > 3 && item.val.val < 7">Оптимальная</span>
										<span v-if="item.val.val >= 7">Максимальная</span>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="mobSet_content">
						<div v-for="item in settings.formatList.ShockTiltSensors">
							<div v-if="item.key === '0x0282' ||
												 item.key === '0x0283'"
								 class='mobSet_form-group__vertical'>
							<div class="mobSet_form-group">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<div>
									<label class="switcher"
												 v-on:click="changeSlider(item, 9)">
										<input type="checkbox" v-model="item.val.on">
										<div class="switcher_checked">
											<div class="switcher_status">
											</div>
										</div>
										<div class="switcher_toddler">
										</div>
									</label>
								</div>
							</div>
							<div v-bind:class="{ 'sliderDisabled' : !item.val.on }">
								<div>
									<vue-slider
											ref="slider"
											v-model="item.val.val"
											v-bind="settings.options.ShockNotify"
											v-on:change="changeSlider(item, 9)"
									></vue-slider>
								</div>
								<div class="slidebar_sensivity text-small">
									Чувствительность:
									<span v-if="item.val.val <= 3">Слабая</span>
									<span v-if="item.val.val > 3 && item.val.val < 8">Оптимальная</span>
									<span v-if="item.val.val >= 8">Максимальная</span>
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- Notification -->
		<div class="settings-section" v-if="activeSettingsItem === 5">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Оповещения
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content" v-if="notif['phone1']">
					<div class="mobSet_content">
						<!-- p1 -->
						<div class="notification-menu_item notification-menu_item__phone">
							<masked-input
									v-model="notif['phone1'].val" mask="+11111111111" placeholder="Номер телефона" type="tel" />
							<span class="change-phone" v-on:click="savePhone('phone1')">Сохранить</span>
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone1CallEvents' }"
								 v-on:click="changeNotifCurrent('phone1CallEvents')">
							<span class="notification-menu-icon icon-phone"></span>
							Звонки на телефон
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone1SmsEvents' }"
								 v-on:click="changeNotifCurrent('phone1SmsEvents')">
							<span class="notification-menu-icon icon-sms"></span>
							SMS уведомления
						</div>
						<!-- p2 -->
						<div class="notification-menu_item notification-menu_item__phone">
							<masked-input
									v-model="notif['phone2'].val" mask="+11111111111" placeholder="Номер телефона" type="tel" />
							<span class="change-phone" v-on:click="savePhone('phone2')">Сохранить</span>
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone2CallEvents' }"
								 v-on:click="changeNotifCurrent('phone2CallEvents')">
							<span class="notification-menu-icon icon-phone"></span>
							Звонки на телефон
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone2SmsEvents' }"
								 v-on:click="changeNotifCurrent('phone2SmsEvents')">
							<span class="notification-menu-icon icon-sms"></span>
							SMS уведомления
						</div>
						<!-- p3 -->
						<div class="notification-menu_item notification-menu_item__phone">
							<masked-input
									v-model="notif['phone3'].val" mask="+11111111111" placeholder="Номер телефона" type="tel" />
							<span class="change-phone" v-on:click="savePhone('phone3')">Сохранить</span>
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone3CallEvents' }"
								 v-on:click="changeNotifCurrent('phone3CallEvents')">
							<span class="notification-menu-icon icon-phone"></span>
							Звонки на телефон
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone3SmsEvents' }"
								 v-on:click="changeNotifCurrent('phone3SmsEvents')">
							<span class="notification-menu-icon icon-sms"></span>
							SMS уведомления
						</div>
						<!-- p4 -->
						<div class="notification-menu_item notification-menu_item__phone">
							<masked-input
									v-model="notif['phone4'].val" mask="+11111111111" placeholder="Номер телефона" type="tel" />
							<span class="change-phone" v-on:click="savePhone('phone4')">Сохранить</span>
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone4CallEvents' }"
								 v-on:click="changeNotifCurrent('phone4CallEvents')">
							<span class="notification-menu-icon icon-phone"></span>
							Звонки на телефон
						</div>
						<div class="notification-menu_phone-notif"
								 v-bind:class="{ 'notification-menu_phone-notif__active' : notifParam.current === 'phone4SmsEvents' }"
								 v-on:click="changeNotifCurrent('phone4SmsEvents')">
							<span class="notification-menu-icon icon-sms"></span>
							SMS уведомления
						</div>

						<!-- -->
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Параметры связи</span>
						</div>
						<div class="form-item">
							<div class="form-title">
								Запрос баланса по номеру
							</div>
							<div class="form-item_balance">
								<label class="form-control form-control__empty">
									<input type="text" placeholder="*100#" class="form-field" v-model="notif['USSD'].val">
								</label>
								<button class="btn btn-success"
												v-on:click="savePhone('USSD')"
												type="button">Сохранить</button>
							</div>
						</div>
						<!-- -->
						<div class="settings-shared_item">
							<label class="mobSet_form-group"
										 v-on:change="setSelected(notif['GsmRoamEnable'])">
								<div class="mobSet_field-name">
									{{notif['GsmRoamEnable'].name}}
								</div>
								<div class="checkbox">
									<input type="checkbox" v-model="notif['GsmRoamEnable'].val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>
						<div class="settings-shared_item">
							<label class="mobSet_form-group"
										 v-on:change="setSelected(notif['GprsRoamEnable'])">
								<div class="mobSet_field-name">
									{{notif['GprsRoamEnable'].name}}
								</div>
								<div class="checkbox">
									<input type="checkbox" v-model="notif['GprsRoamEnable'].val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>
						<div class="settings-shared_item">
							<label class="mobSet_form-group"
										 v-on:change="setSelected(notif['SMSRoamEnable'])">
								<div class="mobSet_field-name">
									{{notif['SMSRoamEnable'].name}}
								</div>
								<div class="checkbox">
									<input type="checkbox" v-model="notif['SMSRoamEnable'].val">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>

						<div class="settings-shared_item">
							<div class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{notif['WaitAnswerTimeout'].name}}
								</div>
								<vue-slider
										ref="slider"
										v-model="notif['WaitAnswerTimeout'].val"
										v-bind="settings.options.WaitAnswerTimeout"
										v-on:change="changeSlider(notif['WaitAnswerTimeout'])"
								></vue-slider>
								<div>
									{{notif['WaitAnswerTimeout'].val}} сек
								</div>
							</div>
						</div>

						<div class="settings-shared_item">
							<div class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{notif['CallEndTimeout'].name}}
								</div>
								<vue-slider
										ref="slider"
										v-model="notif['CallEndTimeout'].val"
										v-bind="settings.options.CallEndTimeout"
										v-on:change="changeSlider(notif['CallEndTimeout'])"
								></vue-slider>
								<div>
									{{notif['CallEndTimeout'].val}} сек
								</div>
							</div>
						</div>

						<div class="settings-shared_item">
							<div class="mobSet_form-group__vertical">
								<div class="mobSet_field-name">
									{{notif['TripEndTimeout'].name}}
								</div>
								<vue-slider
										ref="slider"
										v-model="notif['TripEndTimeout'].val"
										v-bind="settings.options.TripEndTimeout"
										v-on:change="changeSlider(notif['TripEndTimeout'])"
								></vue-slider>
								<div>
									{{notif['TripEndTimeout'].val}} сек
								</div>
							</div>
						</div>

						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Настройки оповещения</span>
						</div>
						<div class="settings-shared_item">
							<div class='mobSet_form-group__vertical'>
								<div class="mobSet_form-group">
									<div class="mobSet_field-name">
										{{notif['LowBatteryVoltage'].name}}
									</div>
								</div>
								<div>
									<vue-slider
											ref="slider"
											v-model="notif['LowBatteryVoltage'].val.val"
											v-bind="settings.options.LowBatteryVoltage"
											v-on:change="changeSlider(notif['LowBatteryVoltage'])"
									></vue-slider>
								</div>
								<div>
									Ниже {{(notif['LowBatteryVoltage'].val.val/10).toFixed(1) }}В
								</div>
							</div>

						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="mobSet_content">
						<div v-if="notifParam.current !== -1">
							<div v-for="(item, itemIndex) in notifParam.list"
									 class="settings-shared_item">
								<label class="mobSet_form-group"
											 v-on:change="changeNotif()">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div class="checkbox">
										<input type="checkbox" v-model="notif[notifParam.current].val[itemIndex]">
										<div class="checkbox_img">
										</div>
									</div>
								</label>
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- OptionsPro -->
		<div class="settings-section" v-if="activeSettingsItem === 6">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Опции PRO версии
				</div>
				<p class="text-base">
					<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>

			<perfect-scrollbar>
				<div class="settings-content" v-if="settings.formatList.OptionsPro.length">
					<div class="mobSet_content">

						<div class="settings-shared_item"
								 v-if="item.key !== '0x02C5' &&
								 		   item.key !== '0x02C6' &&
								 		   item.key !== '0x02C7' &&
								 		   item.key !== '0x02C8'"
								 v-for="(item, itemIndex) in settings.formatList.OptionsPro">

							<div v-if="item.key === '0x02C1'"
									 class='mobSet_form-group__vertical'>
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c0"
													:options="settings.options.TripLocTimeout"
													:value='settings.options.TripLocTimeout[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, itemIndex)"
													label="name"></v-select>
							</div>
							<div v-else-if="item.key === '0x02C2'"
									 class='mobSet_form-group__vertical'>
								<div class="mobSet_field-name">
									{{item.name}}(при эвакуации)
								</div>
								<v-select ref="selectC"
													name="c1"
													:options="settings.options.TripLocTimeout"
													:value='settings.options.TripLocTimeout[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, itemIndex)"
													label="name"></v-select>

							</div>
							<div v-else-if="item.key === '0x02C4'"
									 class='mobSet_form-group__vertical'
									 style="margin-bottom: 100px">
								<div class="mobSet_field-name">
									{{item.name}}
								</div>
								<v-select ref="selectC"
													name="c1"
													:options="settings.options.TimeZone"
													:value='settings.options.TimeZone[item.val]'
													:searchable="false"
													:clearable="false"
													@input="setSelected(item, itemIndex)"
													label="name"></v-select>
							</div>
							<div v-else class="settings-shared_item">
								<label class="mobSet_form-group"
											 v-on:change="setSelected(item, indexItem)">
									<div class="mobSet_field-name">
										{{item.name}}
									</div>
									<div class="checkbox">
										<input type="checkbox"
													 v-model="item.val">
										<div class="checkbox_img">
										</div>
									</div>
								</label>
							</div>

						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="mobSet_content">
						<div class="usersettings_form-control"
								 v-if="item.key === '0x02C6' ||
											 item.key === '0x02C7' ||
											 item.key === '0x02C8'"
								 v-for="(item) in settings.formatList.OptionsPro">
							<div class="usersettings_form-name">
									{{item.name}}
							</div>
							<div class="usersettings_form-field">
								<input type="text"
											 v-if="item.key === '0x02C6'"
											 v-model="item.val">
								<input type="text"
											 v-else-if="item.key === '0x02C7'"
											 v-model="item.val">
								<input type="password"
											 v-else
											 v-model="item.val"/>
							</div>
						</div>
						<div class="usersettings_form-control text-right">
							<button class="btn btn-success" v-on:click="saveAPN">Сохранить</button>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- Share -->
		<div class="settings-section" v-if="activeSettingsItem === 7">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Общий доступ к автомобилю
				</div>
				<p class="text-base">
					<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content">
					<div class="settings-content_col settings-content_col__space">
						<div v-if="share.list.length > 0">
							<div class="settings-shared_item"
									 v-for="(user, indexUser) in share.list"
									 v-bind:key="indexUser">
								<div class="form-item">
									<div class="form-title">
										Пользователь зарегистрированный в системе Universe
									</div>
									<label class="form-control form-control__empty">
										<span v-if="user.user_fio">{{user.user_fio}}</span>
										<span v-else>{{user.user_email}}</span>
									</label>
									<div class="list-notifications_importance">
										<div class="list-notifications_importance-item"
												 v-for="(type, sharedLvlIndex) in share.lvl"
												 v-bind:class="{'list-notifications_importance-item__active' : sharedLvlIndex === user.active }"
												 v-bind:key="sharedLvlIndex"
												 v-on:click="changeSharedAccess( sharedLvlIndex, indexUser, type.id )">
											<span>{{type.name}}</span>
										</div>
									</div>
									<div class="text-italic">
										Информация о текущем положении
										и состоянии автомобиля
									</div>
									<div class="text-right">
										<a href="javascript:void(0)" class="btn btn-clean" v-on:click="delUser( share.list[indexUser].id, indexUser )">Удалить пользователя</a>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="settings-operation">
								Нет добавленных пользователей
							</div>
						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="settings-content_col settings-content_col__space">
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Добавление нового пользователя</span>
						</div>
						<div class="settings-shared_item">
							<div class="form-item">
								<div class="form-title">
									Email зарегистрированного в системе Universe пользователя
								</div>
								<label class="form-control form-control__empty">
									<input type="text" placeholder="example@mail.com" class="form-field" v-model="share.newUser.user_email">
								</label>
								<div class="list-notifications_importance">
									<div class="list-notifications_importance-item"
											 v-for="(type, sharedLvlIndex) in share.lvl"
											 v-bind:key="sharedLvlIndex"
											 v-bind:class="{'list-notifications_importance-item__active' : share.newUser.active === sharedLvlIndex }"
											 v-on:click="share.newUser.id = type.id; share.newUser.active = sharedLvlIndex">
										<span>{{type.name}}</span>
									</div>
								</div>
								<div class="text-italic">
									{{share.lvl[share.newUser.active].description}}
								</div>
								<div class="text-right">
									<a href="javascript:void(0)" class="btn btn-clean" v-on:click="addNewUser()">Добавить пользователя</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<!-- About -->
		<div class="settings-section" v-if="activeSettingsItem === 8">
			<div class="options-panel_head">
				<div class="s-title text-green">
					Информация об устройстве
				</div>
				<p class="text-base">
					<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
				</p>
			</div>
			<div class="style-hr__solid">
			</div>
			<perfect-scrollbar>
				<div class="settings-content">
					<div class="settings-content_col settings-content_col__space">
						<div class="generalSettings_list">
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Охранная система
								</div>
								<div class="generalSettings_value">
									{{deviceModel}}
								</div>
							</div>
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Серийный номер
								</div>
								<div class="generalSettings_value">
									{{deviceSetting.serial}}
								</div>
							</div>
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Номер сим.карты
								</div>
								<div class="generalSettings_value">
									{{deviceSetting.msisdn}}
								</div>
							</div>
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Валюта сим.карты
								</div>
								<div class="generalSettings_value">
									<span v-if="deviceSetting.currency === 'rub'">Российский рубль</span>
									<span v-else>{{deviceSetting.currency}}</span>
								</div>
							</div>
							<!--
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Код выполнения команд через голосовое меню
								</div>
								<div class="generalSettings_value">
									{{deviceSetting.pin}}
								</div>
							</div>
							-->
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Телефон технической поддержки
								</div>
								<div class="generalSettings_value">
									{{deviceSetting.tehsupport}}
								</div>
							</div>
							<div class="generalSettings_list-item">
								<div class="generalSettings_name">
									Телефон экстренной службы
								</div>
								<div class="generalSettings_value">
									{{deviceSetting.emergency}}
								</div>
							</div>
						</div>

            <div v-if="deviceSetting.type === 2">
              <div class="form-item" v-if="tarif.current !== 'none' && tarif.balance !== 'none'">
                <div class="style-hr style-hr__solid">
                </div>
              </div>

              <div class="tarif" v-if="tarif.current !== 'none' && tarif.balance !== 'none'">
                <div class="tarif-line">
                  <div class="tarif-name">
                    Тариф «{{tarif.current.name}}»
                  </div>
                  <div class="tarif-change" v-on:click="infoPanel = 1">
                    Сменить
                  </div>
                </div>
                <div class="tarif-line">
                  <div>
                    Баланс
                  </div>
                  <div class="text-small">
                    {{tarif.balance.balance}}
                    &#8381;
                  </div>
                </div>
                <div class="tarif-line tarif-line__no-padd">
                  <div class="tarif-line_item">
                    <div class="tarif-line_item-name">
                      Интернет
                    </div>
                    <div class="tarif-line_item-val">
                      <span v-if="tarif.current.internet.out_free_cnt">{{tarif.current.internet.out_free_cnt}} Мб</span>
                      <span>{{tarif.current.internet.out_price}}  &#8381;/Мб</span>
                    </div>
                  </div>
                  <div class="tarif-line_item">
                    <div class="tarif-line_item-name">
                      Минуты
                    </div>
                    <div class="tarif-line_item-val">
                      <span v-if="tarif.current.call.out_free_cnt">{{tarif.current.call.out_free_cnt}} мин</span>
                      <span>{{tarif.current.call.out_price}}  &#8381;/мин</span>
                    </div>
                  </div>
                  <div class="tarif-line_item">
                    <div class="tarif-line_item-name">
                      SMS
                    </div>
                    <div class="tarif-line_item-val">
                      <span v-if="tarif.current.sms.out_free_cnt">{{tarif.current.sms.out_free_cnt}}</span>
                      <span>{{tarif.current.sms.out_price}}  &#8381;</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tarif" v-else>
                <div class="tarif-line">
                  <div class="tarif-name">
                    Тариф не выбран
                  </div>
                  <div class="tarif-change" v-on:click="infoPanel = 1">
                    Выбрать
                  </div>
                </div>
              </div>
            </div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="settings-content_col settings-content_col__space">
						<div v-if="infoPanel === 1 && tarif.list.length">
							<div class="tarif-item"
									 v-for="item in tarif.list">
								<div class="tarif-line tarif-line__head">
									<div class="tarif-name">
										Тариф «{{item.name}}»
									</div>
								</div>
								<div class="tarif-option">
									<i class="tarif-option_icon icon-internet"></i>
									<div class="tarif-option_title">
										Интернет
									</div>
									<div class="tarif-option_line" v-if="item.internet.out_free_cnt">
										<div class="tarif-option_name text-small">
											Объем мобильного интернета(МБ)
										</div>
										<div class="tarif-option_val">
											{{item.internet.out_free_cnt}}
										</div>
									</div>
									<div class="tarif-option_line">
										<div class="tarif-option_name text-small">
											Мобильный интернет по тарифу или сверх пакета(за МБ)
										</div>
										<div class="tarif-option_val">
											{{item.internet.out_price}} &#8381;
										</div>
									</div>
									<div class="tarif_additional">
										<div class="text-small"
												 v-for="(adit, aditIndex) in item.internet.additional">
											<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
											{{adit.text}}
											<a v-if="adit.type === 'tariff_link'"
												 target="_blank"
												 v-bind:href="adit.val">{{adit.val}}</a>
										</div>
									</div>
								</div>
								<div class="tarif-option">
									<i class="tarif-option_icon icon-sms"></i>
									<div class="tarif-option_title">
										СМС сообщения
									</div>
									<div class="tarif-option_line" v-if="item.sms.out_free_cnt">
										<div class="tarif-option_name text-small">
											Включенный объем сообщений в месяц
										</div>
										<div class="tarif-option_val">
											{{item.sms.out_free_cnt}}
										</div>
									</div>
									<div class="tarif-option_line">
										<div class="tarif-option_name text-small">
											На все номера по тарифу или сверх пакета
										</div>
										<div class="tarif-option_val">
											{{item.sms.out_price}} &#8381;
										</div>
									</div>
									<div class="tarif_additional">
										<div class="text-small"
												 v-for="(adit, aditIndex) in item.sms.additional">
											<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
											{{adit.text}}
											<a v-if="adit.type === 'tariff_link'"
												 target="_blank"
												 v-bind:href="adit.val">{{adit.val}}</a>
										</div>
									</div>
								</div>
								<div class="tarif-option">
									<i class="tarif-option_icon icon-telephone"></i>
									<div class="tarif-option_title">
										Звонки
									</div>
									<div class="tarif-option_line" v-if="item.call.out_free_cnt">
										<div class="tarif-option_name text-small">
											Включенный объем минут в месяц на номера РФ
										</div>
										<div class="tarif-option_val">
											{{item.call.out_free_cnt}}
										</div>
									</div>
									<div class="tarif-option_line">
										<div class="tarif-option_name text-small">
											На все номера РФ по тарифу или сверх пакета
										</div>
										<div class="tarif-option_val">
											{{item.call.out_price}} &#8381;
										</div>
									</div>
									<div class="tarif_additional">
										<div class="text-small"
												 v-for="(adit, aditIndex) in item.call.additional">
											<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
											{{adit.text}}
											<a v-if="adit.type === 'tariff_link'"
												 target="_blank"
												 v-bind:href="adit.val">{{adit.val}}</a>
										</div>
									</div>
								</div>
								<div class="tarif_additional">
									<div class="text-small"
											 v-for="(adit, aditIndex) in item.additional">
										<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
										{{adit.text}}
										<a v-if="adit.type === 'tariff_link'"
											 target="_blank"
											 v-bind:href="adit.val">{{adit.val}}</a>
									</div>
								</div>
								<div class="tarif-line">
									<div v-if="item.subscription">
										<span class="tarif-title tarif-title__line"><b>{{item.subscription}}</b> &#8381;</span> / месяц
									</div>
									<div v-else>
										<b>Без абонентской платы</b>
									</div>
									<div v-if="tarif.current !== 'none'">
										<button class="btn btn-disable"
														v-if="item.id === tarif.current.id"
														disabled="disabled">Тариф подключен</button>
										<button class="btn btn-warning"
														v-else
														v-on:click="changeTarif(item.id)">перейти на тариф</button>
									</div>
									<button class="btn btn-warning"
													v-else
													v-on:click="changeTarif(item.id)">перейти на тариф</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
	</div>
</template>

<script>
  import { HTTP, HTTP_COMM }  from  '../../main'
  import vueSlider 						from  'vue-slider-component'
  import MaskedInput          from  'vue-masked-input';

  export default {
    data : function () {
      return{
        listServices : {},
        trial : {
          status : 'cant',
          data : {}
        },
        info : {},
				infoPanel : 0,

        // Шара
        share : {
          list : [],
          lvl : [
            {
              "id": 2,
              "name": "Управление",
              "description": "Автомобилем пользуются попеременно несколько водителей. Все водители имеют равные возможности в повседневном использовании приложения. Доступ к настройкам и обновлению ПО имеет только владелец."
            },
            {
              "id": 3,
              "name": "Помощник",
              "description": "Доступ предоставляется для оказания сторонней помощи в настройках ПО. Например, Вы можете предоставить доступ нашему специалисту техподдержки или своему знакомому."
            },
            {
              "id": 4,
              "name": "Наблюдение",
              "description": "Предоставляется доступ к текущему положению автомобиля, например, членам семьи."
            },
            {
              "id": 5,
              "name": "Отчеты",
              "description": "Ответственному лицу компании предоставляются данные для составления отчетов по пробегу и расходу топлива."
            },
            {
              "id": 6,
              "name": "Мониторинг",
              "description": "Диспетчеру предоставляются данные о текущем положении автомобиля и данные для составления отчетов по пробегу и расходу топлива."
            }
          ],
          newUser : {
            active : 0,
            id: 2,
            user_email: ""
          },
        },

				settings : {
          wait : '',
					options : {
						'LightsAutoStartMode' : [
							{ val : 0, name : 'Отключен' },
							{ val : 1, name : 'Только при включении/выключении автозапуска автозапуска автозапуска автозапуска' },
							{ val : 2, name : 'При включении/выключении и работе автозапуска' }
    				],
						'IlluminationMode' : [
							{ val : 0, name : 'Выключено' },
							{ val : 1, name : 'Постановка на охрану' },
							{ val : 2, name : 'Снятие с охраны' },
							{ val : 3, name : 'Постановка на охрану и Снятие с охраны' },
						],
						'LockByDriveMode' : [
              { val : 0, name : 'Нет' },
              { val : 1, name : 'По педали тормоза ' },
              { val : 2, name : 'По началу движения' }
						],
						'UnlockByParkMode' : [
							{ val : 0, name : 'Выкл' },
							{ val : 1, name : 'При включении стояночного тормоза ' },
							{ val : 2, name : 'При выключении зажигания' },
						],
						'ArmReturnTimeIndex' : [
							{ val : 0, name : 'Выключено' },
							{ val : 1, name : 'Через 30 секунд' },
						],
						'HandsfreeMode' : [
							{ val : 0, name : 'Выключено' },
							{ val : 1, name : 'Автоматически включать режим охраны при удалении от автомобиля' },
							{ val : 2, name : 'Автоматически выключать режим охраны при приближении к автомобилю' },
							{ val : 3, name : 'Автопостановка и автоснятие' },
						],
            'TurboTimerIndex' : [
							{ val : 0, name : 'Выключено' },
							{ val : 1, name : '120 секунд' },
							{ val : 2, name : 'Интеллектуальный режим, не более 120 секунд' }
						],
						'ReadyMinutes' : {
								width:       360,
								height:        2,
								dotSize:      14,
								min:           0,
								max:           8,
								interval:      1,
								disabled:  false,
								show:       true,
								speed:       0.3,
								reverse:   false,
								lazy:      false,
								piecewise:  true,
							  marks:      true,
              	tooltip:   'none'
						},
						'SupportMinutes' : {
              width:       360,
              height:        2,
              dotSize:      14,
							min:          10,
              max:          60,
              interval:      5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise:  true,
              marks:      true,
              tooltip:   'none'
						},
						'PitStopTimeIndex' : [
							{ val : 0, name : '15 минут' },
							{ val : 1, name : '30 минут' },
							{ val : 2, name : '60 минут' },
							{ val : 3, name : 'не ограничен по времени' }
            ],
						'SetReadyMode' : [
							{ val : 0, name : 'С брелока или смартфона'},
							{ val : 1, name : 'При включении стояночного тормоза'},
							{ val : 2, name : 'При включении стояночного тормоза при открытой двери"'}
						],
						'AutostartBatteryLevel' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:         108,
              max:         126,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise:  true,
              marks:      true,
							tooltip:   'none'
						},
						'AutostartTemperature' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:         -30,
              max:         60,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'ShockNotify' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           1,
              max:           9,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'ShockAlarm' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           1,
              max:           8,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'WaitAnswerTimeout' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           5,
              max:          60,
              interval:      5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'CallEndTimeout' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           5,
              max:          60,
              interval:      5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'TripEndTimeout' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           5,
              max:          60,
              interval:      5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'LowBatteryVoltage' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:         110,
              max:         125,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              piecewise: false,
              tooltip:   'none'
						},
						'TripLocTimeout' : [
							{ val :  0,  name : 'Отключено'  },
							{ val :  6,  name : '1 минута' },
							{ val : 30,  name : '5 минут'  },
							{ val : 60,  name : '10 минут' },
							{ val : 90,  name : '15 минут' },
						],
						'TimeZone' : [
              { val : -11, name : '(GMT-11:00) Остров Мидуэй, Самоа' },
              { val : -10, name : '(GMT-10:00) Гавайи' },
              { val :  -9, name : '(GMT-09:00) Аляска' },
              { val :  -8, name : '(GMT-08:00) Тихоокеанское время (США и Канада)' },
              { val :  -7, name : '(GMT-07:00) Горное время (США и Канада)' },
              { val :  -6, name : '(GMT-06:00) Центральное время (США и Канада)), Мехико' },
              { val :  -5, name : '(GMT-05:00) Восточное время (США и Канада)), Богота, Лима' },
              { val :  -4, name : '(GMT-04:00) Атлантическое время (Канада)), Каракас, Ла-Пас' },
              { val :  -3, name : '(GMT-03:00) Бразилия, Буэнос-Айрес, Джорджтаун' },
              { val :  -2, name : '(GMT-02:00) Срединно-Атлантического' },
              { val :  -1, name : '(GMT-01:00) Азорские острова, острова Зеленого Мыса' },
              { val :   0, name : '(GMT 00:00) Время Западной Европе, Лондон, Лиссабон, Касабланка' },
              { val :   1, name : '(GMT+01:00) Брюссель, Копенгаген, Мадрид, Париж' },
              { val :   2, name : '(GMT+02:00) Калининград, Киев, Южная Африка' },
              { val :   3, name : '(GMT+03:00) Москва, Санкт-Петербург,Багдад, Эр-Рияд' },
              { val :   4, name : '(GMT+04:00) Самара, Абу-Даби, Баку, Тбилиси' },
              { val :   5, name : '(GMT+05:00) Екатеринбург, Исламабад, Карачи, Ташкент' },
              { val :   6, name : '(GMT+06:00) Новосибирск,Алматы, Дакке, Коломбо' },
              { val :   7, name : '(GMT+07:00) Новокузнецк, Бангкок, Ханой, Джакарта' },
              { val :   8, name : '(GMT+08:00) Иркутск, Пекин, Перт, Сингапур, Гонконг' },
              { val :   9, name : '(GMT+09:00) Якутск, Токио, Сеул, Осака, Саппоро' },
              { val :  10, name : '(GMT+10:00) Владивосток,Сахалин,Магадан,Восточная Австралия,Гуам' },
              { val :  11, name : '(GMT+11:00) Соломоновы острова, Новая Каледония' },
              { val :  12, name : '(GMT+12:00) Камчатка, Окленд, Веллингтон, Фиджи' },
						],

            'videoReg' : {
              width:       360,
              height:        2,
              dotSize:      14,
              min:           0,
              max:         240,
              interval:     12,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:      false,
              piecewise:  true,
              marks:      true,
              tooltip:   'none'
            },
            'videoRegStart' : [
              { val : 0, name : 'В тревоге' },
              { val : 0, name : 'При работающем двигателе' },
              { val : 0, name : 'При включенном зажигании' },
              { val : 0, name : 'В автозапуске' },
              { val : 0, name : 'В панике' }
            ],
            'videoRegEnd' : [
              { val : 0, name : 'По окончании цикла тревог' },
              { val : 0, name : 'При выключении двигателя' },
              { val : 0, name : 'При выключении зажигания' },
              { val : 0, name : 'По окончании автозапуска' },
              { val : 0, name : 'По окончании паники' }
            ],
						dayWeek : [
					 		'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'
						]
					},
          formatList : {
            SoundAndLights 		:	[],
            SecuritySystem 		: [],
            Autostart 				:	[],
            ShockTiltSensors  : [],
            Notification 			: [],
            OptionsPro 				:	[]
          },
          bitArray : {
						SoundAndLights   : String.fromCharCode('064', '001', '065', '001', '066', '001', '068', '001', '074', '001', '072', '001', '098', '001', '110', '001'),
            SecuritySystem 	 : String.fromCharCode('130', '001', '131', '001', '132', '001', '133', '001', '135', '001', '137', '001', '163', '001', '167', '001', '168', '001', '000', '002', '169', '001', '170', '001', '172', '001', '174', '001', '175', '001', '132', '002', '144', '002', '145', '002', '146', '002', '147', '002'),
						Autostart 		   : String.fromCharCode('064', '002', '065', '002', '066', '002', '067', '002', '071', '002', '078', '002', '079', '002', '084', '002', '085', '002', '094', '002', '095', '002', '096', '002', '097', '002', '098', '002', '099', '002', '100', '002', '101', '002', '102', '002', '103', '002', '104', '002', '105', '002', '106', '002', '107', '002'),
            ShockTiltSensors : String.fromCharCode('128', '002', '129', '002', '130', '002', '131', '002'),
            Notification     : String.fromCharCode('160', '002', '161', '002', '162', '002', '163', '002', '164', '002', '165', '002', '166', '002', '167', '002', '168', '002', '169', '002', '170', '002', '171', '002', '176', '002', '177', '002', '178', '002', '179', '002', '180', '002', '181', '002', '182', '002', '183', '002'),
						OptionsPro       : String.fromCharCode('192', '002', '193', '002', '194', '002', '195', '002', '196', '002', '197', '002', '198', '002', '199', '002', '200', '002')
					},
          dictionary : {
            // ---- [ Звуковые сигналы и световая сигнализация ] ----
						// Световая индикация
						'0x0140' : {
						  key : '064001',
              id : 	'LightsArm',
							name : 'Постановка на охрану'
						},
						'0x0141' : {
						  key : '065001',
              id : 'LightsDisarm',
							name : 'Снятие с охраны'
						},
						'0x0142' : {
						  key : '066001',
						  id : 'LightsAlarm',
							name : 'Тревога охранной системы'
						},
						'0x0144' : {
							// 0 - Отключен,
							// 1 - Только при включении/выключении автозапуска,
							// 2 - При включении/выключении и работе автозапуска
							key : '068001',
							id : 'LightsAutoStartMode',
							name : 'Световой сигнал автозапуска'
						},
            '0x014A' : {
						  key : '074001',
              id : 'LightsShockNotify',
              name : 'Предупреждение от датчика удара'
            },
						// Вежливая подсветка
            '0x0148' : {
						  // 0 = выключено;
							// 1 = Постановка на охрану;
							// 2 = Снятие с охраны;
							// 3 = Постановка на охрану и Снятие с охраны.
							key : '072001',
							id : 'IlluminationMode',
							name : 'Вежливая подсветка',
						},
						// Звуковые сигналы
            '0x0162' : {
						  key : '098001',
							id : 'SoundsDisable',
							name : 'Отключить все звуки'
						},
						'0x016E' : {
						  key : '110001',
						  id : 'SoundsNoticesDisable',
							name : 'Отключить звуковые уведомления'
						},

						// ---- [ Параметры охранной системы ] ----
						// Центральный замок
						'0x0182' : {
						  // 0 нет
							// 1 по педали тормоза
							// 2 по началу движения
							key : '130001',
						  id : 'LockByDriveMode',
							name : 'Запирание ЦЗ'
						},
						'0x0183' : {
              key : '131001',
						  id : 'LockOnAutostartBegin',
							name : 'Закрыть при начале автозапуска'
						},
						'0x0184' : {
              key : '132001',
						  id : 'LockOnAutostartEnd',
							name : 'Закрыть при окончании автозапуска'
						},
						'0x0185' : {
              key : '133001',
						  id : 'LockOnAlarmEnd',
							name : 'Закрыть при завершении тревоги'
						},
						'0x0187' : {
						  // 0 - выкл
							// 1 - при включении стояночного тормоза
							// 2 -при выключении зажигания
              key : '135001',
						  id : 'UnlockByParkMode',
							name : 'Отпирание ЦЗ '
						},
						'0x0189' : {
              key : '137001',
						  id : 'UnlockPriority',
							name : 'Приоритетное открытие двери водителя'
						},
						// Автопостановка и автоснятие
						'0x01A3' : {
						  // 0 - выключено
							// 1 - Через 30 секунд
              key : '163001',
						  id : 'ArmReturnTimeIndex',
							name : 'Перепостановка на охрану'
						},
						'0x01A7' : {
              // 0-выключено
              // 1 - Автоматически включать режим охраны при удалении от автомобиля (автопостановка)
              // 2-Автоматически выключать режим охраны при приближении к автомобилю (автоснятие)
              // 3 - Автопостановка и автоснятие
              key : '167001',
						  id : 'HandsfreeMode',
							name : 'Автопостановка и автоснятие'
						},
						// Идентификация владельца
						'0x01A8' : {
              key : '168001',
							id : 'DisarmWithTagOnly',
							name : 'Защита при краже брелока'
						},
            '0x0200' : {
              key : '000002',
              id : 'Immobilizer',
              name : 'Иммобилайзер'
            },
						// Штатная сигнализация
						'0x01A9' : {
              key : '169001',
						  id : 'DriveBuiltinSystem',
							name : 'Охранная система управляет штатной сигнализацией'
						},
						'0x01AA' : {
              key : '170001',
						  id : 'SlaveModeEnable',
							name : 'Штатная сигнализация управляет охранной системой'
						},
						// Общее
						'0x01AC' : {
						  // 4 цифры
              key : '172001',
							id : 'DisarmEmergPinVal',
							name : 'PIN-код аварийного снятия с охраны'
						},
            '0x0284' : {
						  // 0 - Ничего не делать
							// 1 - Включить аварийный сигнал
							// 2 - Включить аварийный сигнал и отпереть дверные замки
              key : '132002',
						  id : 'EmergencyBraking',
							name : 'Аварийная ситуация'
            },
            // Видеорегистратор
            '0x0290' : {
              key : '144002',
              id : 'DVR_SwOnCommandTime',
              name : 'Длительность работы видеорегистратора по команде'
            },
            '0x0293' : {
              key : '147002',
              id : 'DVR_SwOffDelayEvents',
              name : 'Длительность задержки выключения видеорегистратора'
            },
            '0x0291' : {
              key : '145002',
              id : 'DVR_SwOnEvents',
              name : 'Включать видеорегистратор'
            },
            '0x0292' : {
              key : '146002',
              id : 'DVR_SwOffDelayEvents',
              name : 'Здержка выключения видеорегистратора'
            },
            // Без категории
            '0x01AE' : {
              key : '174001',
              id : 'SlaveDisarmWithTagOnly',
              name : 'Выключение охраны по SLAVE-входу только при наличии метки'
            },
            '0x01AF' : {
              key : '175001',
              id : 'SlaveDisarmAutoStartOnly',
              name : 'Выключение охраны по SLAVE-входу только в режимах Автозапуска'
            },


						// ---- [ Автозапуск ] ----
						'0x0240' : {
              // 0 - Выключено
							// 1 - 120 секунд
							// 2 - Интеллектуальный режим, не более 120 секунд
              key : '064002',
						  id : 'TurboTimerIndex',
							name : 'Турботаймер'
						},
						'0x0241' : {
              // 1 - 8 минут
              key : '065002',
						  id : 'ReadyMinutes',
							name : 'Поддержка зажигания'
						},
						'0x0242' : {
              // 10 - 60
              key : '066002',
						  id : 'SupportMinutes',
							name : 'Время работы двигателя при автозапуске'
						},
						'0x0243' : {
						  // 0 - 15 минут
							// 1 - 30 минут
							// 2 - 60 минут
							// 3 - не ограничен по времени
              key : '067002',
						  id : 'PitStopTimeIndex',
							name : 'Парковка с работающим двигателем' //Длительность режима
						},
						'0x0247' : {
						  // 0 - С брелока или смартфона
							// 1 - При включении стояночного тормоза
							// 2 - При включении стояночного тормоза при открытой двери
              key : '071002',
						  id : 'SetReadyMode',
							name : 'Включить поддержку зажигания'
						},
						'0x024E' : {
              key : '078002',
						  id : 'StopByDisarm',
							name : 'Заглушить двигатель при снятии с охраны'
						},
						'0x024F' : {
              key : '079002',
						  id : 'ClrReadyMode',
							name : 'Отключить при закрытии последней двери'
						},
						'0x0254' : {
						  // false < 108, Значения 108-126(10,8 - 12,6, шаг 0,1)
              key : '084002',
						  id : 'AutostartBatteryLevel',
							name : 'Запуск двигателя при напряжении'
						},
						'0x0255' : {
              // -30 - 128 и в битовое значение, если меньше -30, то выключено
              key : '085002',
						  id : 'AutostartTemperature',
							name : 'Запуск двигателя по температуре'
						},
						// Start Таймеры автозапуска
						'0x025E' : {
						  // TStartTimerSetting
							// Cмотреть редмайн
              key : '094002',
							id : 'TimerRun0',
							name : 'Автозапуск по расписанию'
						},
						'0x025F' : {
              key : '095002',
						  id : 'TimerRun1',
              name : 'Автозапуск по расписанию'
						},
						'0x0260' : {
              key : '096002',
						  id : 'TimerRun2',
              name : 'Автозапуск по расписанию'
						},
						'0x0261' : {
              key : '097002',
						  id : 'TimerRun3',
              name : 'Автозапуск по расписанию'
						},
						'0x0262' : {
              key : '098002',
						  id : 'TimerRun4',
              name : 'Автозапуск по расписанию'
						},
						'0x0263' : {
              key : '099002',
						  id : 'TimerRun5',
              name : 'Автозапуск по расписанию'
						},
						'0x0264' : {
              key : '100002',
						  id : 'TimerRun6',
              name : 'Автозапуск по расписанию'
						},
						'0x0265' : {
              key : '101002',
						  id : 'TimerRun7',
              name : 'Автозапуск по расписанию'
						},
						'0x0266' : {
              key : '102002',
						  id : 'TimerRun8',
              name : 'Автозапуск по расписанию'
						},
						'0x0267' : {
              key : '103002',
						  id : 'TimerRun9',
              name : 'Автозапуск по расписанию'
						},
						'0x0268' : {
              key : '104002',
						  id : 'TimerRun10',
              name : 'Автозапуск по расписанию'
						},
						'0x0269' : {
              key : '105002',
						  id : 'TimerRun11',
              name : 'Автозапуск по расписанию'
						},
						'0x026A' : {
              key : '106002',
						  id : 'TimerRun12',
              name : 'Автозапуск по расписанию'
						},
						'0x026B' : {
              key : '107002',
						  id : 'TimerRun13',
              name : 'Автозапуск по расписанию'
						},
            // End Таймеры автозапуска

						// ---- [ Датчики удара и наклона ] ----
						'0x0280' : {
						  // Чувствительность для предупреждения: 0..6
              key : '128002',
							id : 'ShockNotify',
							name : 'Предупреждение по датчику удара'
						},
						'0x0281' : {
						  // Чувствительность для удара: 0..5
              key : '129002',
							id : 'ShockAlarm',
							name : 'Тревога по датчику удара'
						},
						'0x0282' : {
						  // Чувствительность для наклона: 0..5
              key : '130002',
							id : 'TiltAlarm',
							name : 'Наклон автомобиля'
						},
            '0x0283' : {
              // Чувствительность для наклона: 0..5
              key : '131002',
						  id : 'MotionAlarm',
							name : 'Движение автомобиля'
            },

            // ---- [ Оповещения ] ----
						// Телефоны
						'0x02A0' : {
              key : '160002',
						  id : 'phone1',
							name : 'номер телефона 1' // в международном формате например "+79161234567"'
						},
						'0x02A1' : {
              key : '161002',
						  id : 'phone2',
							name : 'номер телефона 2'
						},
						'0x02A2' : {
              key : '162002',
						  id : 'phone3',
							name : 'номер телефона 3'
						},
						'0x02A3' : {
              key : '163002',
						  id : 'phone4',
							name : 'номер телефона 4'
						},
						// Смс оповещения

						'0x02A4' : {
              key : '164002',
						  id : 'phone1SmsEvents',
							name : 'Список событий'
						},
            '0x02A5' : {
              key : '165002',
              id : 'phone2SmsEvents',
              name : 'Список событий'
            },
            '0x02A6' : {
              key : '166002',
              id : 'phone3SmsEvents',
              name : 'Список событий'
            },
            '0x02A7' : {
              key : '167002',
              id : 'phone4SmsEvents',
              name : 'Список событий'
            },
						// Оповещения по звонку
            '0x02A8' : {
              key : '168002',
              id : 'phone1CallEvents',
              name : 'Список событий'
            },
            '0x02A9' : {
              key : '169002',
              id : 'phone2CallEvents',
              name : 'Список событий'
            },
            '0x02AA' : {
              key : '170002',
              id : 'phone3CallEvents',
              name : 'Список событий'
            },
            '0x02AB' : {
              key : '171002',
              id : 'phone4CallEvents',
              name : 'Список событий'
            },
            // Опции
						'0x02B0' : {
              key : '176002',
						  id : 'USSD',
							name : 'номер для запроса баланса'
						},
						'0x02B1' : {
              key : '177002',
						  id : 'GsmRoamEnable',
							name : 'Разрешены голосовые операции в роуминге'
						},
						'0x02B2' : {
              key : '178002',
						  id : 'GprsRoamEnable',
							name : 'Разрешена передача данных по GPRS в роуминге'
						},
						'0x02B3' : {
              key : '179002',
							id : 'SMSRoamEnable',
							name : 'Разрешена передача SMS в роуминге'
						},
						'0x02B4' : {
              key : '180002',
						  id : 'WaitAnswerTimeout',
							name : 'Время ожидания ответа абонента при оповещении',
							step : '' // 20; 5..60; 5
						},
						'0x02B5' : {
              key : '181002',
							id : 'CallEndTimeout',
							name : 'Таймаут окончания звонка при бездействии абонента',
							step : '' // 10; 5..60; 5
						},
						'0x02B6' : {
						  // Поездка считается законченной, если:
            	// - включается режим охраны;
      				// - проходит заданное этим параметром время после выключения зажигания.
              key : '182002',
						  id : 'TripEndTimeout',
							name : 'Таймаут окончания поездки при выключении зажигания',
							step : '' // 15; 5..60; 5
						},
						'0x02B7' : {
              key : '183002',
						  id : 'LowBatteryVoltage',
							name : 'Пороговое значение входного напряжения',
							step : '' // 118; 110..125; 1
						},

						// ---- [ Опции PRO версии ] ----]
            '0x02C0' : {
						  // Устройство будет вычислять координаты по БС при окончании поездки.
              key : '192002',
						  id : 'ParkingLocRequest',
							name : 'Определять место парковки по БС' // Базовая станция
            },
						'0x02C1' : {
						  // 0 минут -не определять.
							// Устройство будет вычислять координаты по БС во время поездки через заданный промежуток времени.
              key : '193002',
							id : 'TripLocTimeout',
							name : 'Интервал определения маршрута поездки по БС',
              step : '' // 1; 1..15; 1
						},
						'0x02C2' : {
              // 0 минут -не определять.
						  // Устройство будет вычислять координаты по БС при эвакуации автомобиля поездки через заданный промежуток времени
              key : '194002',
						  id : 'EvacLocTimeout',
							name : 'Интервал определения маршрута поездки по БС',
							step : '' // 1; 1..15; 1
						},
						'0x02C3' : {
						  // В текст SMS будут включены последние известные координаты или ссылка на место на карте.
              // Должна быть включена одна и функций:
							// 		ParkingLocRequest,
							// 		TripLocTimeout > 0,
							// 		EvacLocTimeout > 0,
							// 		LocFromPhone.
              key : '195002',
						  id : 'SMSLoc',
							name : 'Добавлять координаты в SMS'
						},
						'0x02C4' : {
						  // Только целочисленные зоны. Для отправки системного времени UTC+0 на брелок
							// 3; -12..+12; 1
              key : '196002',
						  id : 'TimeZone',
							name : 'Часовой пояс пользователя'
						},
            '0x02C5' : {
							// Показывать, но менять нельзя
              key : '197002',
							id : 'VersionPRO',
							name : 'Признак версии PRO' // Подключение к серверу по GPRS
            },
            '0x02C6' : {
              key : '198002',
						  id : 'ModemAPN',
							name : 'Строка APN провайдера'
            },
						'0x02C7' : {
						  // строка
              key : '199002',
						  id : 'ModemLogin',
							name : 'Login'
						},
						'0x02C8' : {
						  // строка
              key : '200002',
						  id : 'ModemPassword',
							name : 'Password'
						},
					},
				},

				notifParam : {
          current : -1,
					list : [
            {
              index : 0,
              name : 'Включение режима Автосервис',
              id : 26,
              val : false
            },
            {
              index : 1,
              name : 'Выключение режима Автосервис',
              id : 226,
              val : false
            },
            {
              index : 2,
              name : 'Снятие с охраны',
              id : 27,
              val : false
            },
            {
              index : 3,
              name : 'Постановка на охрану',
              id : 28,
              val : false
            },
            {
              index : 4,
              name : 'Включение зажигания',
              id : 14,
              val : false
            },
            {
              index : 5,
              name : 'Нарушение периметра',
              id : 205,
              val : false
            },
            {
              index : 6,
              name : 'Датчик удара',
              id : 15,
              val : false
            },
            {
              index : 7,
              name : 'Датчик наклона',
              id : 17,
              val : false
            },
            {
              index : 8,
              name : 'Датчик перемещений',
              id : 18,
              val : false
            },
            {
              index : 9,
              name : 'Тревога по внешнему датчику',
              id : 20,
              val : false
            },
            {
              index : 10,
              name : 'Тревога по питанию системы',
              id : 19,
              val : false
            },
            {
              index : 11,
              name : 'Тревога штатной охранной системы',
              id : 22,
              val : false
            },
            {
              index : 12,
              name : 'Неисправность при постановке под охрану',
              id : 33,
              val : false
            },
            {
              index : 13,
              name : 'Попытка завести двигатель с включенным иммобилайзером',
              id : 213,
              val : false
            },
            {
              index : 14,
              name : 'Нажата кнопка вызова водителя',
              id : 214,
              val : false
            },
            {
              index : 15,
              name : 'Падение напряжения ниже порога в охране',
              id : 215,
              val : false
            },
            {
              index : 16,
              name : 'Блокировка исполнения команд',
              id : 216,
              val : false
            },
            {
              index : 17,
              name : 'Устройство приняло SMS/USSD',
              id : -7,
              val : false
            },
            {
              index : 18,
              name : 'Включение Автозапуска по команде',
              id : 218,
              val : false
            },
            {
              index : 19,
              name : 'Включение Автозапуска по событию',
              id : 219,
              val : false
            },
            {
              index : 20,
              name : 'Окончание Автозапуска',
              id : 47,
              val : false
            },
            {
              index : 21,
              name : 'Прерывание Автозапуска',
              id : 48,
              val : false
            },
            {
              index : 22,
              name : 'Запрет на включение Автозапуска',
              id : 49,
              val : false
            },
            {
              index : 23,
              name : 'Включение предпускового подогревателя',
              id : 50,
              val : false
            },
            {
              index : 24,
              name : 'Выключение предпускового подогревателя',
              id : 51,
              val : false
            }
          ]
				},

				selects : {
          current : ''
				},

				slider : {
          key : '',
					timeout : ''
				},

				tarif : {
          current : 'none',
					list 		: [],
					balance : 'none'
				}
      }
    },
    computed : {
      currentCar : function(){
        return this.$store.state.cars.current
      },
      deviceSetting : function(){
        return this.$store.state.cars.list[this.currentCar.index].device;
      },
      activeSettingsItem : function () {
        return this.$store.state.panels.settings
      },
      lastCMD : function () {
        return this.$store.state.cars.lastSocket.cmd
      },
			// Global Preloader
      globalPreloader : function () {
        return this.$store.state.preloaders.global
      },
			notif : function () {
				return this.settings.formatList.Notification;
      },

      deviceModel : function (){
        let res = ''

        switch ( this.deviceSetting.model ) {
          case 1  :
            res = 'Universe 1';
            break;
          case 2  :
            res = 'Universe 2';
            break;
          case 3  :
            res = 'Universe 3';
            break;
          case 4  :
            res = 'Universe 4';
            break;
          case 10 :
            res = 'Mobicar A';
            break;
          case 11 :
            res = 'Mobicar B';
            break;
          case 12 :
            res = 'Mobicar 1';
            break;
          case 13 :
            res = 'Mobicar 2';
            break;
          case 14 :
            res = 'Mobicar 3';
            break;
          case 15 :
            res = 'Mobicar 4';
            break;
          case 25 :
            res = 'Scherkhan X1';
            break;
          case 26 :
            res = 'Scherkhan X2';
            break;
          case 27 :
            res = 'Scherkhan X2M';
            break;
          case 28 :
            res = 'Scherkhan X3';
            break;
          case 29 :
            res = 'Scherkhan X4';
            break;
          default :
            res = undefined
            break;
        }

        return res;
      }
    },
    mounted : async function () {
      if( this.deviceSetting.type === 2 ){
        this.tooglePreloader();
        await this.getCarData();
        await this.getTrial();
        await this.getInfo();
        this.tooglePreloader();
      }
    },
    methods : {
      getTarif : async function(){

        this.tooglePreloader();

        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=tariff')
          .then( response => {
            this.tarif.current = response.data;
          })
          .catch(error => {
            this.tarif.current = 'none';
						console.log( error );
          });

        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=balance')
          .then( response => {
            this.tarif.balance = response.data;
          })
          .catch(error => {
            this.tarif.balance = 'none';
            console.log( error );
          });

        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=tariff_all')
          .then( response => {
            this.tarif.list = response.data;
          })
          .catch(error => {
            this.tarif.list = [];
            console.log( error );
          });

        this.tooglePreloader();
			},
      changeTarif : function( id ){
        HTTP.post( 'cars/' + this.currentCar.id + '/device/operator/',
          {
            service_type : "tariff",
            tariff_id : id
          })
          .then( () => {
            this.getTarif();
            this.$store.dispatch( 'addAlert', { text : 'Тариф изменен', type : 'success' });
          })
          .catch( error => {
            this.$store.dispatch('errorResponse', error );
          });
      },

      saveAPN : function(){
        let arr = ['198', '199', '200'];
        let res = '';

				for( let i = 0; i < 3; i++ ){
				  let len = (i === 0) ? '32' : '16';

          let a = this.settings.formatList.OptionsPro[i+6].val.split('');
          res += String.fromCharCode( arr[i], '002', len );

          for( let j = 0; j < len; j++ ){
            if( a[j] !== undefined ){
              res += a[j];
            }else{
              res += '\u0000'
            }
          }
				}

        this.saveSetting( res );
			},
      savePhone : function( name ){
        let keyV = this.settings.dictionary[this.notif[name].key].key.substring(0, 3);
        let keyL = this.settings.dictionary[this.notif[name].key].key.substring(3, 6);

        let res = String.fromCharCode( keyV, keyL, 16 );
        let a   = this.notif[name].val.split('');

        for( let i = 0; i < 16; i++ ){
          if( a[i] !== undefined ){
            res += a[i];
					}else{
            res += String.fromCharCode( 0 );
					}
				}

        this.saveSetting( res );
			},

      changeNotifCurrent : function( name ){
        if( this.notifParam.current === name ){
          this.notifParam.current = -1;
				}else{
          this.notifParam.current = name;
				}
			},
      changeNotif : function(){
        let keyV = this.settings.dictionary[this.notif[this.notifParam.current].key].key.substring(0, 3);
        let keyL = this.settings.dictionary[this.notif[this.notifParam.current].key].key.substring(3, 6);
        let b = [];

        let a = this.notif[this.notifParam.current].val.map( item => {
          if( item === true ){
            return 1
          }else if( item === false ){
            return 0
          }else{
            return item
          }
        });

        b.push( parseInt( a.slice( 0,  8).reverse().join(''), 2) );
        b.push( parseInt( a.slice( 8, 16).reverse().join(''), 2) );
        b.push( parseInt( a.slice(16, 24).reverse().join(''), 2) );
        b.push( parseInt( a.slice(24, 32).reverse().join(''), 2) );


        let res = String.fromCharCode( keyV, keyL, '04', b[0], b[1], b[2], b[3] );

        this.saveSetting( res );
			},
      changeSlider : function(item, maxL){

        this.slider.key = item.key;

        if( this.slider.timeout !== '' ){
          clearTimeout(this.slider.timeout)
				}
				this.slider.timeout = setTimeout( () => {
          let keyV = this.settings.dictionary[item.key].key.substring(0, 3);
          let keyL = this.settings.dictionary[item.key].key.substring(3, 6);
          let valL = '01';
          let valV;
          if(  item.val.val !== undefined ){
            if( item.val.on ){
              valV = item.val.val;
						}else{
              valV = maxL + 1;
						}
					}else{
            valV = item.val;
					}

          this.saveSetting( String.fromCharCode( keyV, keyL, valL, valV ) );

          this.slider.timeout = '';

          for( let i = 0; i < this.$refs.slider.length; i++ ){
            this.$refs.slider[i].blur();
					}

        }, 1200);

			},

      // Change Time
      changeTime : function( item ){
        if( item.val.fHours > 23 ){
          item.val.fHours = 23;
				}
				if( item.val.fMinuts > 59 ){
          item.val.fMinuts = 59
				}

				item.val.minuts = parseInt(item.val.fHours * 60) + parseInt(item.val.fMinuts);
			},
			// Change Day Week
      changeDayWeek : function( item, index ){
				if( item.val.days[index] === 1 ){
          item.val.days.splice(index, 1, 0);
				}else{
          item.val.days.splice(index, 1, 1);
				}
			},
			// Add Autostart
      addAutostart : function(){
				let list = this.settings.formatList.Autostart;
				for( let i = 9; i < list.length; i++ ){
					if( list[i].val.minuts === '' ){
            list[i].val.fHours = '01';
            list[i].val.fMinuts = '01';

            list[i].val.minuts = parseInt(list[i].val.fHours * 60) + parseInt(list[i].val.fMinuts);
            break;
					}
				}
			},

      // Start Info
      getInfo : function(){
        return HTTP_COMM.get('/billing/v1/info/')
          .then( (response) => {
            this.info = response.data;
          })
          .catch( error => {
            this.$store.dispatch('errorResponse', error );
          })
          ;
      },
      getCarData( pay ){
        return HTTP_COMM.get('/billing/v1/services/' + this.currentCar.id + '/').then( (response) => {
          this.listServices = response.data;
          if( pay ){
            // this.getSber();
            this.makePayment();
          }
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      getTrial(){
				let res = false;
				HTTP_COMM.get('/billing/v1/trial/' + this.currentCar.id)
					.then( (response) => {
					  res = true;
						this.trial.data = response.data;
						this.trial.status = 'used';
					}).catch( ( error ) => {
						if( error.response.status === 404 ){
							this.trial.status = 'can';
						}else if( error.response.status === 402 ){
							this.trial.status = 'cant';
						}
					});
				return res;
      },

      setTrial(){
        HTTP_COMM.post('/billing/v1/trial/' + this.currentCar.id + '/').then( () => {
          this.getCarData();
          this.getTrial();

          HTTP.get('cars/' + this.currentCar.id + '/device/').then( response => {
            this.$store.dispatch('deviceList', {
              id : this.currentCar.index,
              data : response.data
            });
          }).catch( () => {
            this.$store.dispatch('deviceList', {
              id : this.currentCar.index,
              data : { type : 0 }
            });
          });
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

			// Sber
      getSber : function () {
        let _this = this;

        let options = {
          api_token: 'aqu2sn5k7410cm1ljarcpq75tl',
          language: 'en',
          classNamePreloader: 'payment-preloader',
          preloadBorderColor: '#13a024'
        };

        function createPreloader() {
          let preloadBlock = document.createElement('div'),
            preloader = document.createElement('div'),
            style = document.createElement('style'),
            keyFrames = '\
                  @-webkit-keyframes load8 {\
                      0% {\
                          -webkit-transform: rotate(0deg);\
                          transform: rotate(0deg);\
                      }\
                      100% {\
                          -webkit-transform: rotate(360deg);\
                          transform: rotate(360deg);\
                      }\
                  }\
                  @keyframes load8 {\
                       0% {\
                            -webkit-transform: rotate(0deg);\
                            transform: rotate(0deg);\
                       }\
                      100% {\
                            -webkit-transform: rotate(360deg);\
                            transform: rotate(360deg);\
                      }\
                  }';

          preloadBlock.style.cssText = "position: fixed; \
                                height: 100%;\
                                left: 0; \
                                top: 0; \
                                width: 100%; \
                                background-color: rgba(27, 27, 27, 0.3); \
                                z-index: 100; \
                                display: none; \
                                ";

          preloader.style.cssText    =  "margin: auto; \
                                 top: 0; \
                                 bottom: 0; \
                                 left: 0; \
                                 right: 0; \
                                 border-radius: 50%; \
                                 width: 9em; \
                                 height: 9em; \
                                 font-size: 8px; \
                                 position: absolute; \
                                 text-indent: -9999em; \
                                 border-top: 1.1em solid #fff; \
                                 border-right: 1.1em solid #fff; \
                                 border-bottom: 1.1em solid #fff; \
                                 border-left-width: 1.1em; \
                                 border-left-style: solid;\
                                 transform: translateZ(0); \
                                 -webkit-animation: load8 1s infinite linear;\
                                 animation: load8 1s infinite linear;\
                                 ";

          preloader.style.borderLeftColor = options.preloadBorderColor;

          style.innerHTML = keyFrames;
          document.querySelector('head').appendChild(style);

          preloadBlock.className = options.classNamePreloader;

          preloadBlock.appendChild(preloader);
          document.body.appendChild(preloadBlock);

          return preloadBlock;
        }
        createPreloader();

        let preloader = document.querySelector('.' + options.classNamePreloader);
        preloader.style.display = 'block';
        window.addEventListener('message', gotEvent);

        let orderData = {
          amount  : parseFloat(this.listServices[0].order.amount),
          currency: this.listServices[0].currency.toString(),
          order_number: this.listServices[0].order.order_number,
          description: this.listServices[0].order.description
        };

        function createIframe(order) {
          let iframe     = document.createElement('iframe'),
            iframeStyle  = iframe.style,
            orderStr     = JSON.stringify(order),
            scrollLeft   = window.pageXOffset,
            scrollTop    = window.pageYOffset + 'px';

          iframeStyle.position  = 'absolute';
          iframeStyle.width     = '100%';
          iframeStyle.height    = '100%';
          iframeStyle.minHeight = '600px';
          iframeStyle.display   = 'block';
          iframeStyle.border    = '0px';
          iframeStyle.top       = '0px';
          iframeStyle.left      = scrollLeft + 'px';
          iframeStyle.overflowX = 'hidden';
          iframeStyle.overflowY = 'scroll';
          iframeStyle.zIndex    = '10000';
          iframe.id             = options.api_token;
          iframe.src            = 'https://securepayments.sberbank.ru/payment/docsite/payform-1.html?token='
            + options.api_token
            + '&modal=true&order='
            + orderStr;

          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('data-offset', scrollTop);


          document.body.insertBefore(iframe, document.body.firstChild);

          return iframe;
        }
        createIframe(orderData);

        let iframe = document.querySelector('iframe');

        function gotEvent(e) {
          let data = e.data,
            offset = parseInt(iframe.getAttribute('data-offset')) || window.pageYOffset,
            preloader = document.querySelector('.' + options.classNamePreloader),
            scroll = {
              offset: offset
            };

          // Fix chrome bug
          if (typeof e.data === 'string') {
            data = JSON.parse(e.data);
          }
          if (!('type' in data)) {
            return;
          }
          switch (data.type) {
            case 'LOADED':
              if (data) {
                scroll = JSON.stringify(scroll);
                window.scrollTo(0, parseInt(offset));
                document.getElementById(options.api_token).contentWindow.postMessage(scroll, '*');
                preloader.style.display = 'none';
              }
              break;

            case 'ACS':
              if (data) {
                iframe.style.backgroundColor = '#fff';
                window.scrollTo(0, 0);
              }
              break;

            case 'APPROVE':
              iframe.style.backgroundColor = 'transparent';
              window.scrollTo(0, offset);
              _this.successPaySber(data.data);
              window.removeEventListener('message', gotEvent);
              break;

            case 'DECLINE':
              iframe.style.backgroundColor = 'transparent';
              window.scrollTo(0, offset);
              _this.declinePaySber(data.data);
              window.removeEventListener('message', gotEvent);
              break;

            case 'CLOSE':
              window.removeEventListener('message', gotEvent);
              break;

            default:
              console.warn('Incorrect iframe message');
          }
        }

        window.addEventListener('message', closeModal);

        function closeModal(e) {
          let data   = e.data;
          if (typeof e.data === 'string') {
            data = JSON.parse(e.data);
          }
          if (!('type' in data)) {
            return;
          }
          if (data.type === 'CLOSE') {
            document.body.removeChild(iframe);
            document.body.getAttribute('style');
            document.body.removeAttribute('style');
            window.removeEventListener('message', closeModal);
          }
        }
      },
      successPaySber(data){
        HTTP_COMM.post('/billing/v1/order/', data).then( (response) => {
          if( response.data.status !== 0 && response.data.status !== 2 ){
            this.getCarData();
            this.trial.status = 'cant';
          }
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      declinePaySber(data){
        console.log( data );
      },

      makePayment : function (){
        const link = '/billing/v1/payments-form/?order_number=' + this.listServices[0].order.order_number;

        HTTP_COMM.get(link).then( (response) => {
          window.open( response.data.redirect_url, '_blank');
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

			// Получаем пользователей кому расшарили авто
      getShare : function () {
        if( this.share.list.length === 0 ){
          HTTP.get('cars/' + this.currentCar.id + '/shares/').then( (response) => {
            let settingsShared = response.data;

            for( let i = 0; i < response.data.length; i++ ){
              settingsShared[i].active = response.data[i].role-2;
            }
            this.share.list = settingsShared;
          }).catch( ( error ) => {
            this.$store.dispatch('errorResponse', error );
          });
        }
      },
      addNewUser : function () {
        if( this.share.newUser.user_email === "" ){
          this.$store.dispatch( 'addAlert', { text : 'Заполните Email пользователя', type : 'error' });
        }else{
          HTTP.post('cars/' + this.currentCar.id + '/shares/', {
            "user": this.share.newUser.user_email,
            "role": this.share.newUser.id
          }).then( ( response ) => {
            this.$store.dispatch( 'addAlert', { text : 'Пользователь добавлен', type : 'success' });
            this.share.list.push( response.data );
          }).catch( ( error ) => {
            this.$store.dispatch('errorResponse', error );
          });
        }
      },
      changeSharedAccess : function ( indlvl, indUser, id ) {
        this.share.list[indUser].active = indlvl;

        //  car_id  share_id
        HTTP.patch('cars/' + this.currentCar.id + '/shares/' + this.share.list[indUser].id + '/', {
          "role": id
        }).then( () => {
          this.$store.dispatch( 'addAlert', { text : 'Изменения сохранены', type : 'success' });
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      delUser : function ( id, userIndex ) {
        HTTP.delete('cars/' + this.currentCar.id + '/shares/' + id + '/')
					.then( () => {
						this.share.list.splice( userIndex, 1 );
						this.$store.dispatch( 'addAlert', { text : 'Пользователь удален', type : 'success' });
					}).catch( ( error ) => {
						this.$store.dispatch('errorResponse', error );
					})
				;
      },

      // Получение настроек
      getSettings : function( type ){
        this.tooglePreloader();
        let res;
        switch ( type ){
          case 'SoundAndLights' :
            this.settings.formatList.wait = 'SoundAndLights';
            res = this.settings.bitArray.SoundAndLights;
            break;
          case 'SecuritySystem':
            this.settings.formatList.wait = 'SecuritySystem';
            res = this.settings.bitArray.SecuritySystem;
            break;
          case 'Autostart':
            this.settings.formatList.wait = 'Autostart';
            res = this.settings.bitArray.Autostart;
            break;
          case 'ShockTiltSensors':
            this.settings.formatList.wait = 'ShockTiltSensors';
            res = this.settings.bitArray.ShockTiltSensors;
            break;
          case 'Notification':
            this.settings.formatList.wait = 'Notification';
            res = this.settings.bitArray.Notification;
            break;
          case 'OptionsPro':
            this.settings.formatList.wait = 'OptionsPro';
            res = this.settings.bitArray.OptionsPro;
            break;
        }
        this.settings.formatList.wait = type;
        res = window.btoa( res );

        HTTP.post(
          'cars/' + this.currentCar.id + '/command/',
						{
							"cmd"  : "get_settings",
							"data" : res
						}
					)
          .then( () => {

          }).catch( ( error ) => {
          	this.$store.dispatch('errorResponse', error );
        	});
      },
      formatSettings : function( bytes ){
        let type = '',
          arr = [];

        let a = window.atob( bytes ).split('');
        let b = a.map(item => {
          return ( "0" + item.charCodeAt(0).toString(16) ).slice(-2);
        });

        for( let i = 0, j = 0; i < b.length-1; i++ ){
          if( j === 0 ){
            let keyN = '0x' + (b[i+1] + b[i]).toUpperCase();
            j = 1;

            arr.push({
              key : keyN,
              val : false,
              name : this.settings.dictionary[keyN].name,
              id : this.settings.dictionary[keyN].id,
            });

            i++;
          }else{
            let len = parseInt( b[i], 16 ),
              val = '',
              valArr = [],
              minuts,
              onOff,
              l,
              days,
							show,
              fHours,
            	fMinuts;

            if( len === 0 ){
              val = -1;
            }else{
              for( let k = 0; k < len; k++ ){
                i++;

                switch ( arr[arr.length-1].key ){
                  case '0x02A0' :
                  case '0x02A1' :
                  case '0x02A2' :
                  case '0x02A3' :
                  case '0x02B0' :
                  case '0x02C6' :
                  case '0x02C7' :
                  case '0x02C8' :
                    val += a[i].replace('\u0000', '');
                    break;
                  case '0x01AC' :
                    val = parseInt(b[i+1] + b[i], 16);
                    k++;
                    i++;
                    break;
                  case '0x0242' :
                  case '0x02B4' :
                  case '0x02B5' :
                  case '0x02B6' :
                    val += parseInt(b[i], 16);
                    break;
                    // Списки событий
                  case '0x02A4' :
                  case '0x02A5' :
                  case '0x02A6' :
                  case '0x02A7' :
                  case '0x02A8' :
                  case '0x02A9' :
                  case '0x02AA' :
                  case '0x02AB' :
                    valArr.push( parseInt(b[i], 16) );
                    break;
                    // Таймеры
                  case '0x025E' :
                  case '0x025F' :
                  case '0x0260' :
                  case '0x0261' :
                  case '0x0262' :
                  case '0x0263' :
                  case '0x0264' :
                  case '0x0265' :
                  case '0x0266' :
                  case '0x0267' :
                  case '0x0268' :
                  case '0x0269' :
                  case '0x026A' :
                  case '0x026B' :
                    minuts = parseInt( b[i+1] + b[i], 16) & parseInt('3FFF', 16);

                    if( minuts !== 0 ){
                      fHours  = Math.floor(minuts/60).toString();
                      fMinuts = ((minuts) - (Math.floor(minuts/60))*60).toString();

                      if( fHours.length  === 1 ){ fHours  = '0' + fHours }
                      if( fMinuts.length === 1 ){ fMinuts = '0' + fMinuts }
                    }else{
                      minuts  = '';
                      fHours  = '';
                      fMinuts = '';
                    }

                    onOff  = (parseInt( b[i+1]+ b[i], 16 ) >> 14) -1;
                    show = minuts > 0;
                    l = parseInt(b[i+2], 16).toString(2).split('').reverse();
                    days = [];
                    for( let g = 0; g < 7; g++){
                      if( l[g] !== 0 && l[g] !== '0' && l[g] !== undefined ){
                        days.push(1)
                      }else{
                        days.push(0)
                      }
                    }

                    val = {
                      minuts  : minuts,
                      on 		  : onOff,
                      days 	  : days,
                      show    : show,
                      fHours  : fHours,
                      fMinuts : fMinuts
                    };

                    k+=2;
                    i+=2;
                    break;
                    // Напряжение
                  case '0x0254':
                  case '0x02B7':
                    if( parseInt( b[i], 16 ) >= 108 && parseInt( b[i], 16 ) <= 126 ){
                      val = { val: parseInt( b[i], 16), on: 1 }
                    }else{
                      val = { val : parseInt( b[i], 16 ) - 128, on : 0 }
                    }
                    break;
                    //
                  case '0x0255' :
                    if( parseInt( b[i], 16 ) >= -30 && parseInt( b[i], 16 ) <= 60 ){
                      val = { val: parseInt( b[i], 16), on: 1 }
                    }else{
                      val = { val : parseInt( b[i], 16 ) - 128, on : 0 }
                    }
                    break;
                  case '0x026E' :
                    if( parseInt( b[i], 16 ) >= -20 && parseInt( b[i], 16 ) <= 20 ){
                      val = { val: parseInt( b[i], 16), on: 1 }
                    }else{
                      val = { val : parseInt( b[i], 16 ) - 128, on : 0 }
                    }
                    break;
                    // Предупреждение по датчику удара
                  case '0x0280' :
                  case '0x0282' :
                  case '0x0283' :
                    if( parseInt(b[i], 16) >= 0 && parseInt(b[i], 16) <=9 ){
                      val = { val: parseInt(b[i], 16), on: true }
                    }else{
                      val = { val: 0, on: false }
                    }
                    break;
                  case '0x0281' :
                    if( parseInt(b[i], 16) >= 0 && parseInt(b[i], 16) <=8 ){
                      val = { val: parseInt(b[i], 16), on: true }
                    }else{
                      val = { val: 0, on: false }
                    }
                    break;
                  case '0x02C1' :
                  case '0x02C2' :
                    val = parseInt( b[i], 16 );
                    switch ( true ){
                      case val > 75 :
                        val = 4;
                        break;
                      case val < 75 && val > 45 :
                        val = 3;
                        break;
                      case val < 45 && val > 15 :
                        val = 2;
                        break;
                      case val < 15 && val > 0 :
                        val = 1;
                        break;
                      default :
                        val = 0;
                        break;
                    }
                    break;
                  case '0x02C4' :
                    val = parseInt( b[i], 16 );
                    for( let item in this.settings.options.TimeZone ){
                      if( val === this.settings.options.TimeZone[item].val ){
                        val = item;
                        break;
                      }
                    }
                    break;
                    // видеорегистратор
                  case '0x0290' :
                  case '0x0293' :
                    val = a[i].charCodeAt(0)
                    break;
                  case '0x0291' :
                  case '0x0292' :
                    val = a[i].charCodeAt(0).toString(2);
                    if( val.length < 5){ val = '00000'.slice(0, 5 - val.length) + val }
                    val = val.split('').map( valItem => {
                      return parseInt(valItem);
                    });
                    k++;
                    i++;
                    break;
                  default :
                    val = parseInt( b[i] );
                    break;
                }
              }
            }

            if( valArr.length ){
              val = [];
              let mask = '00000000';

              for( let l = 0; l < valArr.length; l++ ){
                val.push( mask.slice(0, 8 - valArr[l].toString(2).length ) + (valArr[l]).toString(2) );
							}
							val = val[0].split('').reverse()
													.concat( val[1].split('').reverse() )
													.concat( val[2].split('').reverse() )
													.concat( val[3].split('').reverse() );
              val = val.map( item => {
                return parseInt( item );
							});

              /*
              for(let l = 0; l < 25; l++){
                if ((valArr[l >> 3] >> (l & 7)) & 1 === 1){
                  val.push(l)
                }
              }
              */
            }

            this.$set(arr[arr.length-1], 'val', val);

            j = 0;
            val = '';
            valArr = []
          }
        }


        let r = arr.map(item => { return item.key });

        let a1 = {};
        switch ( true ){
          case r.indexOf("0x0140") > -1 :
            type = 'SoundAndLights';
            break;
          case r.indexOf('0x0182') > -1 :
            type = 'SecuritySystem';
            break;
          case r.indexOf('0x0240') > -1 :
            type = 'Autostart';
            break;
          case r.indexOf('0x0280') > -1 :
            type = 'ShockTiltSensors';
            break;
          case r.indexOf('0x02A0') > -1 :
            type = 'Notification';
            for( let l = 0; l < arr.length; l++ ){
              a1[arr[l].id] = arr[l];
						}
						arr = a1;
            break;
          case r.indexOf('0x02C0') > -1 :
            type = 'OptionsPro';
            break;
          default :
            break;
        }

        this.$set( this.settings.formatList, type, arr );

        if( this.globalPreloader ){
        	this.tooglePreloader();
        }
      },

      saveTimer : function( item ){

        let keyV = this.settings.dictionary[item.key].key.substring(0, 3);
        let keyL = this.settings.dictionary[item.key].key.substring(3, 6);
        let valL = '03';
        let res  = [String.fromCharCode(keyV, keyL, valL)];

				let a = (item.val.minuts | (item.val.on + 1) << 14).toString(16);
				let b = a[2] + a[3] + a[0] + a[1];
				let c = parseInt( [].concat(item.val.days).reverse().join(''), 2 ).toString(16);

        let v = b + c;

        for( let i = 0; i <= v.length - 1; i+=2 ){
          res += String.fromCharCode( parseInt(v[i] + v[i+1], 16) )
        }

				this.saveSetting( res );
			},

			// Сохранение настроек
      setSelected : function( val, indX ) {
        let keyV = this.settings.dictionary[val.key].key.substring(0, 3);
        let keyL = this.settings.dictionary[val.key].key.substring(3, 6);
        let valL, valV, res;

        if( val.val === true || val.val === false || val.val === 1 || val.val === 0 ){
          valL = '01';
          valV = val.val;
				}
				
        if( val.id === 'LightsAutoStartMode' ){
          valL = '01';
          valV = this.settings.formatList.SoundAndLights[indX].val = this.$refs.selectC[0].mutableValue.val;
				}else if( val.id === "IlluminationMode" ){
          valL = '01';
          valV = this.settings.formatList.SoundAndLights[indX].val = this.$refs.selectC[1].mutableValue.val;
        }else if( val.id === 'LockByDriveMode' ){
          valL = '01';
          valV = this.settings.formatList.SecuritySystem[indX].val = this.$refs.selectC[0].mutableValue.val;
				}else if( val.id === 'UnlockByParkMode' ){
          valL = '01';
          valV = this.settings.formatList.SecuritySystem[indX].val = this.$refs.selectC[1].mutableValue.val;
				}else if( val.id === 'ArmReturnTimeIndex' ){
          valL = '01';
          valV = this.settings.formatList.SecuritySystem[indX].val = this.$refs.selectC[2].mutableValue.val;
				}else if( val.id === 'HandsfreeMode' ){
          valL = '01';
          valV = this.settings.formatList.SecuritySystem[indX].val = this.$refs.selectC[3].mutableValue.val;
				}else if( val.id === 'DisarmEmergPinVal' ){ // 6204
          valL = '02';
          valV = [];
          let v = parseInt(this.settings.formatList.SecuritySystem[indX].val).toString(16);

          if( v.length < 4 ){
            for( let i = 0; i < (4 - v.length); i++ ){
              v = 0 + v
            }
          }

          valV.push( v.substring(2, 4) );
          valV.push( v.substring(0, 2) );

          HTTP.patch('cars/' + this.currentCar.id + '/device/', {
              pin : this.settings.formatList.SecuritySystem[indX].val
            })
            .then( response => {
              this.$store.dispatch('deviceList', {
                id : this.currentCar.index,
                data : response.data
              });
            }).catch( (error) => {
              console.log( error );
            });

        }else if( val.id === 'TurboTimerIndex' ){
          valL = '01';
          valV = this.settings.formatList.Autostart[indX].val = this.$refs.selectC[0].mutableValue.val;
				}else if( val.id === 'TripLocTimeout' ){
					valL = '01';
					valV = this.$refs.selectC[0].mutableValue.val;
				}else if( val.id === 'TimeZone' ){
          valL = '01';
          valV = this.$refs.selectC[2].mutableValue.val;
				}else if( val.id === 'DVR_SwOnEvents'){
          valL = '01';
          valV = parseInt(val.val.map( a => { return Number(a) }).join(''), 2);
        }else if( val.id === 'DVR_SwOffDelayEvents' ){
          valL = '01';
          valV = parseInt(val.val.map( a => { return Number(a) }).join(''), 2);
        }


				if( Array.isArray( valV )  ){
          res = String.fromCharCode( keyV, keyL, valL );
          for( let i = 0; i < valV.length; i++ ){
						res += String.fromCharCode( parseInt( valV[i], 16) );
					}
				}else{
          res = String.fromCharCode( keyV, keyL, valL, valV );
				}

        this.saveSetting( res );
			},
			saveSetting : function ( res ) {
        HTTP.post(
          'cars/' + this.currentCar.id + '/command/',
          {
            "cmd"  : "update_settings",
            "data" :  window.btoa( res )
          }
        ).then( () => {
          this.tooglePreloader();
        }).catch( error => {
          this.$store.dispatch('errorResponse', error );
        });
      },

			// Клик вне
      onClickOutside : function ( event ) {
				if( !event.target.closest('.v-select') ){
				  if( this.$refs.selectC ){
						let selC = this.$refs.selectC;
						for( let i = 0; i < selC.length; i++ ){
							if( selC[i] && selC[i].open === true ){
								selC[i].open = false;
							}
						}
						this.selects.current = '';
          }
				}else{
          let indX = parseInt( event.target.closest('.v-select').attributes.name.value.replace('c', '') );
				  if( this.selects.current === '' ){
            this.selects.current = parseInt( indX );
					}else{
						if( indX === this.selects.current ){
              this.$refs.selectC[indX].open = false;
              this.selects.current = ''
						}else{
              for( let i = 0; i < this.$refs.selectC.length; i++ ){
								if( i !== indX ){
                  this.$refs.selectC[i].open = false;
								}
							}
              this.selects.current = indX;
						}
					}
				}
      },

      // Тугл прелоадера
			tooglePreloader : function(){
        this.$store.dispatch('globalPreloader');
			}
    },
    watch : {
      'currentCar' : function (newVal, oldVal) {
        if( newVal.id !== oldVal.id ){
          this.listServices = {};
          this.trial = {
            status : 'cant',
            data : {}
          };

          this.getCarData();
          this.getTrial();
        }
      },
			'activeSettingsItem' : function (newVal, oldVal) {
        if( newVal !== oldVal ){
          switch (newVal){
						case 0:
						  break;
						case 1:
              this.getSettings('SoundAndLights');
						  break;
						case 2:
              this.getSettings('SecuritySystem');
						  break;
						case 3:
              this.getSettings('Autostart');
						  break;
						case 4:
              this.getSettings('ShockTiltSensors');
						  break;
						case 5:
              this.notifParam.current = -1;
              this.getSettings('Notification');
						  break;
						case 6:
              this.getSettings('OptionsPro');
						  break;
						case 7:
              this.getShare();
						  break;
						case 8:
						  if( this.deviceSetting.type === 2 ){
						    this.getTarif();
              }
						  break;
					}
				}
      },
      lastCMD : function ( newVal ) {
        if( newVal.car_id === this.currentCar.id ){
					if( newVal.data.cmd === 'get_settings' && newVal.data.state === 'SUCCESS' ){
					  this.formatSettings( newVal.data.data.settings );
					}
					if( newVal.data.cmd === "update_settings" && newVal.data.state === 'SUCCESS' ){
            if( this.globalPreloader ){ this.tooglePreloader() }
					}
					if( newVal.data.state === "FAIL" && this.globalPreloader ){
					  this.tooglePreloader();
					  console.log('FAIL')
					}
        }
      }
    },
		components:{
      vueSlider,
      MaskedInput
		}
  }
</script>